import { StyleSheet } from 'aphrodite';
import { convertPxToRem } from '../../helper';
import { Colors } from '../../themes/Colors';

export const styles = StyleSheet.create({
  container: {
    textAlign: 'left',
    whiteSpace: 'pre-line',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingTop: convertPxToRem(30),
    paddingLeft: convertPxToRem(32),
    paddingRight: convertPxToRem(32),
    backgroundColor: Colors.white,
    paddingBottom: convertPxToRem(82),
    height: '100%'
  }
});
